import React, { useContext, useEffect } from 'react'
import { appContext } from "../AppContext";
import StormvloedCharacterBuilder from './../components/character/StormvloedCharacterBuilder'
import {
    Mobile,
    // DefaultDevice
  } from '../utils/mediaQuery'
  import { Select } from 'antd';
  
  const { Option } = Select;

export default function CharacterBuilderPage() {
    const [appState, AppDispatch] = useContext(appContext);

    useEffect(() => {
        AppDispatch({ type: "SETSELECTEDPAGE", payload: "Character builder" })
      }, // eslint-disable-next-line
      [])

      function handleChangeSelectStory(value) {

        const selectedStory = appState.stories.find(story => story.id === value)
        AppDispatch({ type: "SETSTORYID", payload: {storyId:value, storyName:selectedStory.name} })
        localStorage.setItem('LarpTOM.StoryId', value);
        localStorage.setItem('LarpTOM.StoryName', selectedStory.name);
      }
      
      const storieOptions = appState.stories.map(story => {
        if(story.name === "Zivania" && !appState.user.isAdmin) {
          return null;
        }
        return (<Option 
          value={story.id} 
          key={story.id}
        >
          {story.name}
        </Option>)
      })
      
    if(appState.storyName !== "Stormvloed") {

        if(appState.storyName.includes("Agnoia")) {
          return <StormvloedCharacterBuilder />
        }
        return (
            <>
            <p>The Character builder is only created for Stormvloed and Agnoia Unwritten. </p>
            <Mobile>
                <Select 
                    onChange={handleChangeSelectStory}
                    value={parseInt(appState.storyId)}
                    >
                        {storieOptions} 
                </Select>
            </Mobile>
            </>
        )
    }

    return (
        <StormvloedCharacterBuilder />
        )
}